import { Component, View, ViewModel } from "binder";
import  { DateSelectorView } from "./dateSelector-view"

export class DateSelectorViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.opentop = false;
        this.allowclear = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new DateSelectorView();
    }
    public getTypeId(): string {
        return "VM-269194FD-7350-44E5-BA77-3C6339E4DB07"
    }

    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date;} private _date: moment.Moment;
    public set startwithyear(v: boolean) { 
        this._startwithyear = (v==true || (<any>v=="true")); 
    } public get startwithyear(): boolean { return this._startwithyear;} private _startwithyear: boolean;
    public set opentop(v: boolean) { this._opentop = v; } public get opentop(): boolean { return this._opentop;} private _opentop: boolean;
    public set allowclear(v: boolean) { this._allowclear = v; } public get allowclear(): boolean { return this._allowclear;} private _allowclear: boolean;
    
}
